import { ApplicationConfig, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withHashLocation, withInMemoryScrolling, withRouterConfig, withViewTransitions } from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { provideAnimations } from '@angular/platform-browser/animations';

import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';

import { registerLocaleData } from '@angular/common';
import localeEsPY from '@angular/common/locales/es-PY';
import { MessageService } from 'primeng/api';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { nfcAuthInterceptor } from './core/interceptors/nfc-auth.interceptor';
import { FormatogsPipe } from './shared/pipes/formatogs.pipe';
import { provideServiceWorker } from '@angular/service-worker';

registerLocaleData(localeEsPY, 'es-PY');

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),

        provideRouter(
            routes,
            withRouterConfig({
                onSameUrlNavigation: 'ignore'
            }),
            withInMemoryScrolling({
                scrollPositionRestoration: 'top',
                anchorScrolling: 'enabled'
            }),
            withEnabledBlockingInitialNavigation(),
            withViewTransitions({ skipInitialTransition: true }), // ⚠️ Comentar esto si el error persiste
            withHashLocation()
        ),

        // ✅ Un solo provideHttpClient con todo junto
        provideHttpClient(withFetch(), withInterceptors([authInterceptor, nfcAuthInterceptor])),

        provideAnimations(),
        providePrimeNG({
            theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } }
        }),
        MessageService,
        FormatogsPipe,
        provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
        })
    ]
};
